import { useState } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { useEquipmentDefects } from '@/hooks/useEquipment'
import { DefectCard } from './GeraetDetailModal'
import { STATUS_CONFIG } from './equipmentUtils'

type Scope = 'offen' | 'aussonderung' | 'alle'

/**
 * Büro-Inbox: offene Defektmeldungen, zu bestätigende Aussonderungen, laufende Reparatur-/Garantiefälle.
 * Aussonderungen stehen oben (Backend sortiert sie zuerst).
 */
export default function DefektInbox({ onOpenEquipment }: { onOpenEquipment: (id: number) => void }) {
  const [scope, setScope] = useState<Scope>('offen')
  const { data, isLoading } = useEquipmentDefects(scope)

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        {([
          ['offen', 'Offen & laufend'],
          ['aussonderung', 'Aussonderung bestätigen'],
          ['alle', 'Alle (Historie)'],
        ] as [Scope, string][]).map(([key, label]) => (
          <button
            key={key}
            onClick={() => setScope(key)}
            className={cn(
              'rounded-md border px-3 py-1.5 text-sm',
              scope === key ? 'border-primary-500 bg-primary-50 text-primary-700' : 'bg-white hover:bg-gray-50',
            )}
          >
            {label}
          </button>
        ))}
      </div>

      {isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : !data?.length ? (
        <p className="rounded-lg border bg-white py-10 text-center text-sm text-gray-400">Nichts zu tun. 🎉</p>
      ) : (
        <div className="grid gap-4 xl:grid-cols-2">
          {data.map((d) => (
            <div key={d.id} className="space-y-1">
              <button
                onClick={() => onOpenEquipment(d.equipment_id)}
                className="flex w-full items-center gap-2 text-left text-sm hover:underline"
              >
                <span className="rounded bg-primary-50 px-1.5 font-mono text-xs font-bold text-primary-700">{d.unique_code}</span>
                <span className="font-medium">{d.equipment_name}</span>
                <span className="text-gray-500">· {d.location_label || '–'}</span>
                {d.equipment_status && (
                  <span className={cn('ml-auto rounded border px-1.5 text-[11px]', STATUS_CONFIG[d.equipment_status]?.className)}>
                    {STATUS_CONFIG[d.equipment_status]?.label}
                  </span>
                )}
              </button>
              <DefectCard defect={d} compact />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
